module.exports = __webpack_public_path__ + "templates.sl_list_page_wishlist_button-b78d623e.html";